module.exports = __webpack_public_path__ + "img/chevronRight.67665fea.svg";